import { StudentActivityReasonCategory, UnenrolmentType } from './enums';

export const MAX_RECENT_LESSONS_TO_TRACK = 8;

export const UNENROLMENT_TYPES = [
  {
    key: UnenrolmentType.Quit,
    value: UnenrolmentType.Quit,
    label: 'Quit',
  },
  {
    key: UnenrolmentType.Move,
    value: UnenrolmentType.Move,
    label: 'Move',
  },
];

export const UNENROLMENT_REASONS = [
  {
    key: StudentActivityReasonCategory.NeverAttended,
    value: StudentActivityReasonCategory.NeverAttended,
    label: 'Never attended',
  },
  {
    key: StudentActivityReasonCategory.TeacherDissatisfaction,
    value: StudentActivityReasonCategory.TeacherDissatisfaction,
    label: 'Teacher dissatisfaction',
  },
  {
    key: StudentActivityReasonCategory.AdminDissatisfaction,
    value: StudentActivityReasonCategory.AdminDissatisfaction,
    label: 'Admin dissatisfaction',
  },
  {
    key: StudentActivityReasonCategory.ServiceDissatisfaction,
    value: StudentActivityReasonCategory.ServiceDissatisfaction,
    label: 'Service dissatisfaction',
  },
  {
    key: StudentActivityReasonCategory.TooEasy,
    value: StudentActivityReasonCategory.TooEasy,
    label: 'Too easy / slow',
  },
  {
    key: StudentActivityReasonCategory.TooHard,
    value: StudentActivityReasonCategory.TooHard,
    label: 'Too hard / fast',
  },
  {
    key: StudentActivityReasonCategory.MismatchingSchedule,
    value: StudentActivityReasonCategory.MismatchingSchedule,
    label: 'Mismatching schedule',
  },
  {
    key: StudentActivityReasonCategory.Full,
    value: StudentActivityReasonCategory.Full,
    label: 'Class is full',
  },
  {
    key: StudentActivityReasonCategory.ScheduleConflict,
    value: StudentActivityReasonCategory.ScheduleConflict,
    label: 'Schedule conflict',
  },
  {
    key: StudentActivityReasonCategory.Graduation,
    value: StudentActivityReasonCategory.Graduation,
    label: 'Graduation',
  },
  {
    key: StudentActivityReasonCategory.DroppedCourse,
    value: StudentActivityReasonCategory.DroppedCourse,
    label: 'Dropped course',
  },
  {
    key: StudentActivityReasonCategory.UnaffordableFees,
    value: StudentActivityReasonCategory.UnaffordableFees,
    label: 'Unaffordable fees',
  },
  {
    key: StudentActivityReasonCategory.AlreadyStudied,
    value: StudentActivityReasonCategory.AlreadyStudied,
    label: 'Already studied / enrolled elsewhere',
  },
  {
    key: StudentActivityReasonCategory.GeographicalInconvenience,
    value: StudentActivityReasonCategory.GeographicalInconvenience,
    label: 'Geographical Inconvenience',
  },
  {
    key: StudentActivityReasonCategory.NoImprovement,
    value: StudentActivityReasonCategory.NoImprovement,
    label: 'No improvement',
  },
  {
    key: StudentActivityReasonCategory.FriendPreference,
    value: StudentActivityReasonCategory.FriendPreference,
    label: 'Be with school / friends',
  },
  {
    key: StudentActivityReasonCategory.Accident,
    value: StudentActivityReasonCategory.Accident,
    label: 'Accidental enrolment / testing',
  },
  {
    key: StudentActivityReasonCategory.ClassCompletion,
    value: StudentActivityReasonCategory.ClassCompletion,
    label: 'Class is finished / cancelled',
  },
  {
    key: StudentActivityReasonCategory.Unknown,
    value: StudentActivityReasonCategory.Unknown,
    label: 'Unknown',
  },
];

const listAttributes = [
  'student',
  'teacher',
  'class',
  'subject',
  'classId',
  'studentState',
  'courseState',
  'actor',
  'activityType',
  'classSize',
  'reason',
  'reasonCategory',
  'creationDatetime',
  'attendedLessonsCount',
  'totalLessonsCount',
  'recentAttendedTeachers',
  'recentAttendedLessons',
] as const;

const getAttributes = [...listAttributes] as const;

export const StudentActivityLogAttributes = {
  List: listAttributes,
  Get: getAttributes,
};
